import React, { useState } from 'react';
import { Layers, List } from 'lucide-react';
import { LaborCreatePatternModal } from './LaborCreatePatternModal';
import { LaborManagePatternsModal } from './LaborManagePatternsModal';

/**
 * Acciones de patrones (vista Patrón): creación, edición y eliminación.
 */
export function LaborPatternSetup({
  factoryId,
  factoryCode,
  year,
  calendarId = null,
  onAfterChange,
  onPatternCreated,
}) {
  const [createOpen, setCreateOpen] = useState(false);
  const [manageOpen, setManageOpen] = useState(false);
  const [lastMessage, setLastMessage] = useState(null);

  const handleCreateSuccess = (result) => {
    const id = result?.patternId;
    const days = result?.daysCreated ?? 0;
    setLastMessage({
      type: 'success',
      text: id
        ? `Patrón creado (ID ${id}, ${days} días). Selecciónalo en el desplegable para ver su calendario.`
        : `Patrón creado con ${days} días.`,
    });
    if (id) onPatternCreated?.(String(id));
    onAfterChange?.();
  };

  const handleManageChange = (options) => {
    setLastMessage({ type: 'success', text: 'Patrones actualizados.' });
    onAfterChange?.(options);
  };

  return (
    <>
      <div className="mb-4 flex flex-wrap items-center gap-3 rounded-lg border border-gray-700 bg-gray-800/80 p-3">
        <span className="text-sm text-gray-400 mr-1">Patrones de trabajo:</span>
        <button
          type="button"
          onClick={() => setCreateOpen(true)}
          disabled={!factoryId}
          className="inline-flex items-center gap-2 px-3 py-2 rounded-lg bg-indigo-600 hover:bg-indigo-500 text-white text-sm font-medium disabled:opacity-50"
        >
          <Layers className="w-4 h-4" />
          Crear patrón
        </button>
        <button
          type="button"
          onClick={() => setManageOpen(true)}
          disabled={!factoryId}
          className="inline-flex items-center gap-2 px-3 py-2 rounded-lg bg-gray-600 hover:bg-gray-500 text-white text-sm font-medium disabled:opacity-50"
        >
          <List className="w-4 h-4" />
          Gestionar patrones
        </button>
        {lastMessage?.type === 'success' && (
          <span className="text-sm text-emerald-400">{lastMessage.text}</span>
        )}
      </div>

      <LaborCreatePatternModal
        isOpen={createOpen}
        onClose={() => setCreateOpen(false)}
        factoryId={factoryId}
        factoryCode={factoryCode}
        defaultYear={year}
        onSuccess={handleCreateSuccess}
      />

      <LaborManagePatternsModal
        isOpen={manageOpen}
        onClose={() => setManageOpen(false)}
        factoryId={factoryId}
        factoryCode={factoryCode}
        defaultYear={year}
        defaultCalendarId={calendarId}
        onAfterChange={handleManageChange}
      />
    </>
  );
}
